import { render, staticRenderFns } from "./userMain.vue?vue&type=template&id=23ca9ecc&scoped=true"
import script from "./userMain.vue?vue&type=script&lang=js"
export * from "./userMain.vue?vue&type=script&lang=js"
import style0 from "./userMain.vue?vue&type=style&index=0&id=23ca9ecc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ca9ecc",
  null
  
)

export default component.exports